<template>
    <div >
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="">拓客利器</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="">精准获客</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>

        <div class="index-clueWrap">
            <div class="index-tabWrp">
                <div class="clue-search">
                    <div class="sx1" :hidden="select1">
                        <div class="left" >
                            <a-select slot="addonBefore" placeholder="单位性质" style="width: 90px" @change="handleChangexz">
                                <a-select-option value="">
                                    全部
                                </a-select-option>
                                <a-select-option value="企业">
                                    企业
                                </a-select-option>
                            </a-select>
                            
                            <a-input v-on:input="inputFunction()" placeholder="域名搜索" style="width: 220px;margin-right:20px" v-model="website">
                                <a-select slot="addonAfter" default-value=".com" style="width: 80px  !important;margin-right:0" @change="handleChangeweb">
                                    <a-select-option value=".com">
                                        .com
                                    </a-select-option>
                                    <a-select-option value=".net">
                                        .net
                                    </a-select-option>
                                    <a-select-option value=".cn">
                                        .cn
                                    </a-select-option>
                                    <a-select-option value=".com.cn">
                                        .com.cn
                                    </a-select-option>
                                    <a-select-option value=".net.cn">
                                        .net.cn
                                    </a-select-option>
                                    <a-select-option value=".org">
                                        .org
                                    </a-select-option>
                                    <a-select-option value=".gov.cn">
                                        .gov.cn
                                    </a-select-option>
                                    <a-select-option value=".cc">
                                        .cc
                                    </a-select-option>
                                    <a-select-option value="">
                                        其它
                                    </a-select-option>
                                </a-select>
                            </a-input>

                            <a-cascader style="margin-right:20px" :field-names="{ label: 'name', value: 'id',children:'children'}" change-on-select  :options="addressoptions" :load-data="loadData"  placeholder="企业地区搜索" @change="onChangeaddress" />

                            <!-- <a-select slot="addonBefore" placeholder="网站状态" style="width: 90px">
                                <a-select-option value="1">
                                    全部
                                </a-select-option>
                                <a-select-option value="2">
                                    已开通
                                </a-select-option>
                                <a-select-option value="3">
                                    未开通
                                </a-select-option>
                            </a-select> -->

                            <!-- <a-button icon="redo">
                            重置
                            </a-button> -->
                        </div>

                        <div class="right" >
                            <a-input-search
                                :placeholder="tstext"
                                enter-button="查询"
                                @search="onSearch"
                                v-model="searchtext"
                                >
                                    <a-select slot="addonBefore" default-value="1" style="width: 120px" 
                                    @change="handleserach">
                                        <a-select-option value="1">
                                            按主办单位
                                        </a-select-option>
                                        <a-select-option value="2">
                                            按行业
                                        </a-select-option>
                                        <a-select-option value="3">
                                            按网站名称
                                        </a-select-option>
    
                                    </a-select>
                            </a-input-search>
                        </div>
                        <!-- <a href="javascript:;" class="right" @click="showsx">
                            <a-icon type="filter" theme="filled" />
                            高级筛选
                        </a> -->
                    </div>

                    <div class="sx2" :hidden="select2">
                        <div v-for="(item,i) in searchlist" :key="i">
                            <div class="sxlist" v-if="item.status==1&&item.type=='radio'" >
                                <div class="sxtitle">{{item.name}}</div>
                                <div class="sxtext">
                            
                                    <span @click="rselected(item.field_name,option,option+x)" :id="item.field_name" :class="{sxed:option+x==current}" v-for="(option,x) in item.option" :key="x">{{option}}</span>
                                </div>
                            </div>

                            <div class="sxlist" v-if="item.status==1&&item.type=='checkbox'" >
                                <div class="sxtitle">{{item.name}}</div>
                                <div class="sxtext">
                                    <span @click="cselected(item.id+option,item.field_name,option)" v-for="(option,x) in item.option" :class="{sxed:searcharr.includes(item.id+option)}" :key="x">{{option}}</span>
                                </div>
                            </div>

                            <div class="sxlist" v-if="item.status==1&&item.type=='address'" >
                                <div class="sxtitle">{{item.name}}</div>
                                <div>
                                    <a-cascader :field-names="{ label: 'name', value: 'id',children:'children'}" change-on-select  :options="addressoptions" :load-data="loadData"  placeholder="请选择企业地区（必填）" @change="onChangeaddress" />
                                </div>
                            </div>

                            <div class="sxlist" v-if="item.status==1&&item.type=='datetime'" >
                                <div class="sxtitle">{{item.name}}</div>
                                <div class="sxtext">
                                    <span v-for="(date,d) in datelist" :key="d" :class="{sxed:date+d==datecurrent}" @click="searchdate(item.field_name,date,date+d)">{{date}}</span>
                                    <div class="time-select">
                                        <span class="time-select-text">自定义时间段</span>
                                        <div class="time-select-hide">
                                            <a-range-picker @change="changdate($event,item.field_name)" />
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div class="sxlist"> 
                            <div class="sxtitle">已选条件</div>
                            <div class="sxtext">
                                <p style="display:inline" v-for="(item,i) in searchlist" :key="i">
                                    <!-- {{dxlist[item.field_name]}} -->
                                    <i v-if="dxlist[item.field_name]!=[]&&dxlist[item.field_name]">
                                        <span class="sxed"  v-for="(option,x) in dxlist[item.field_name]" :key="x">
                                            <label>{{option}}</label> 
                                            <a-icon @click="delsearch(item.id+option,item.field_name,option)" type="close" />
                                        </span>
                                    </i>
                                    
                                    <span class="sxed" v-if="xzlist[item.field_name]">
                                        <label>{{xzlist[item.field_name]}}</label> 
                                        <a-icon @click="deldxsearch(item.field_name)" type="close" />
                                    </span> 
                                </p> 
                            </div>
                        </div>

                        <div class="sxbtn">
                            <a-button @click="setxmodal" icon="setting">设置筛选选项 </a-button>
                            <a href="javascript:;" style="font-size:12px;color:#666" @click="setsx">
                                <a-icon type="filter" theme="filled"/>
                                高级筛选
                            </a>
                        </div>
                    </div>
                
                </div>

                <div class="clue-list">
                    <div class="top-tool" :hidden="cc1">
                        <div class="left">
                            <!-- <router-link to="/addclue"><a-button type="primary" icon="plus">新建</a-button></router-link> 
                            <a-button @click="importmodal" icon="download">导入</a-button>
                            <a-button @click="exportmodal" icon="upload">导出</a-button>
                            <a-button icon="file-search" @click="showcc">查重工具</a-button> -->
                        </div>
                        <!-- <div class="right" >
                            <a-input-search
                                :placeholder="tstext"
                                enter-button="查询"
                                @search="onSearch"
                                v-model="searchtext"
                                >
                                    <a-select slot="addonBefore" default-value="1" style="width: 120px" 
                                    @change="handleserach">
                                        <a-select-option value="1">
                                            按主办单位
                                        </a-select-option>
                                        <a-select-option value="2">
                                            按行业
                                        </a-select-option>
                                        <a-select-option value="3">
                                            按网站名称
                                        </a-select-option>
    
                                    </a-select>
                            </a-input-search>
                        </div> -->
                    </div>

                    <div class="top-tool top-tool2" :hidden="cc2">
                        <div class="left">
                            <a-input-search
                            placeholder="请输入查重内容"
                            enter-button="查重"
                            @search="ccsearch"
                            />
                            <div>查重规则</div>
                            <a-tooltip class="rluetip">
                                <template slot="title">
                                    <p>在线索中查：手机；</p>
                                    <p>在客户中查：客户名称；</p>
                                    <p>在联系人中查：手机；</p>
                                    <p>在商机中查：客户名称、商机名称；</p>
                                </template>
                                <a-icon type="question-circle" theme="filled"/>
                            </a-tooltip>
                        </div>
                        <div class="right">
                            <a-icon type="close" @click="closecc"/>
                        </div>
                    </div>

                    <div class="top-tool top-tool3" :hidden="cc3">
                        <div class="left">
                            <a-button icon="plus">批量拨打</a-button>
                            <a-button icon="download">发送短信</a-button>
                            <a-button icon="upload">创建计划</a-button>
                            <a-button icon="build" @click="setgroupshow">设置分组</a-button>
                            <a-button icon="swap" @click="showbg">变更所属人</a-button>
                            <a-button icon="close-circle" @click="fqmodal">放弃</a-button>
                            <a-button icon="delete" @click="delmodal">删除</a-button>
                            <a-button icon="file-search" @click="plexportmodal">批量导出</a-button>
                        </div>

                    </div>
                    <a-spin :spinning="tablespinning">
                        <a-table class="jzhktable" rowKey="id" :pagination="pageshow" :columns="columns" :data-source="data" :scroll="{ x: '100%'}" >
                        
                            <a slot-scope="text,record" href="javascript:;" slot="name" @click="showDrawer(record._source.id)" >
                                {{ text }}
                            </a>
                        </a-table>

                        <div style="padding-top:30px;width: auto;display: flex;align-items: center;justify-content: flex-start;margin: 15px 12px 12px;">
                            <div class="page-total">总计：{{pagination.total}}条 / {{totalpage}}页</div>
                            <a-pagination
                            show-size-changer
                            :page-size-options="pageSizeOptions"
                            :default-current="1"
                            :total="pagination.total"
                            :defaultPageSize="10"
                            @change="handleTableChange"
                            @showSizeChange="onShowSizeChange"
                            >
                                <template slot="buildOptionText" slot-scope="props">
                                    <span>{{ props.value }}条/页</span>
                                </template>

                            </a-pagination>
                        </div>
                        
                    </a-spin>
                </div>
            </div>
        </div>
        
        

         <!-- 变更所属人 -->
        <a-modal
        title="变更所属人"
        :visible="bgvisible"
        :confirm-loading="confirmLoading"
        @ok="bghandleOk"
        @cancel="handleCancel"
        width="510px"
        okText="保存"
        >
            <div class="bgLog">
                <a-row style="margin-bottom:20px">
                   <a-col :span="5" ><label for="">现有所属人：</label></a-col>
                   <a-col :span="16">
                        <span>程先生</span>
                   </a-col>
               </a-row>
                <a-row>
                   <a-col :span="5" ><label for="" class="required">指定所属人：</label></a-col>
                   <a-col :span="16">
                        <a-select style="width: 100%" @change="bghandleChange">
                            <a-select-option v-for="item in bglist" :key="item.id" :value="item.id">
                                {{item.name}}
                            </a-select-option>
                        </a-select>
                   </a-col>
               </a-row>
            </div> 
        </a-modal>

        <!-- 放弃 -->
        <a-modal
        title="放弃"
        :visible="fqvisible"
        :confirm-loading="confirmLoading"
        @ok="fqhandleOk"
        @cancel="handleCancel"
        width="520px"
        okText="确定"
        >
            <div class="fqLog">
               
               <a-row>
                   <a-col :span="5" ><label for="" class="required">放弃原因</label></a-col>
                   <a-col :span="16">
                        <a-select style="width: 100%" @change="fqreason">
                            <a-icon slot="suffixIcon" type="smile" />
                            <a-select-option v-for="(item,i) in reason" :key="i" :value="item">
                                {{item}}
                            </a-select-option>
                        </a-select>
                   </a-col>
               </a-row>
               <div style="margin: 24px 46px 0px 92px;">
                   <span>*放弃到公海后此客户数据将属于公共资源，原归属人员不能再维护跟进和更新此客户数据。</span>
               </div>
            </div> 
        </a-modal>

        <!-- 导入数据 -->
        <a-modal
            title="批量导入"
            :visible="importvisible"
            :confirm-loading="confirmLoading"
            @ok="importOk"
            @cancel="handleCancel"
            >
            <div class="import-text">
                <svg width="27px" height="20px" viewBox="0 0 27 20" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g id="交互组件" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="业务组件" transform="translate(-120.000000, -1433.000000)" fill-rule="nonzero"><g id="编组-3备份-7" transform="translate(60.000000, 1301.000000)"><g id="Simple-modal备份-5" transform="translate(12.000000, 52.000000)"><g id="编组-5" transform="translate(46.000000, 76.000000)"><g id="批量导入"><rect id="矩形" fill="#000000" opacity="0" x="0" y="0" width="30" height="30"></rect><path d="M29,18.5491733 C29,20.0559059 28.4735,21.3376513 27.417125,22.4046361 C26.36075,23.4716209 25.088375,24 23.6,24 L8.301125,24 C6.56975,24 5.08475,23.3795807 3.8495,22.1319243 C2.617625,20.8876768 2,19.391171 2,17.6355889 C2,16.404977 2.327375,15.2698142 2.9855,14.2266917 C3.643625,13.1835691 4.5245,12.4029317 5.628125,11.8813704 C5.61125,11.5984319 5.59775,11.3938981 5.59775,11.2711778 C5.59775,9.26333731 6.303125,7.54866201 7.707125,6.13056076 C9.111125,4.71245952 10.80875,4 12.796625,4 C14.258,4 15.597875,4.41247656 16.8095,5.23742969 C18.021125,6.06238282 18.905375,7.15663883 19.458875,8.51678882 C20.12375,7.9270496 20.903375,7.63729334 21.791,7.63729334 C22.78325,7.63729334 23.63375,7.99181865 24.33575,8.70427817 C25.041125,9.41673769 25.392125,10.2723709 25.392125,11.2745867 C25.392125,11.993864 25.19975,12.6483723 24.815,13.2347026 C26.033375,13.5278677 27.032375,14.1687404 27.815375,15.1573206 C28.605125,16.1493097 29,17.2776547 29,18.5491733 Z M9.20225,14.9152889 C9.20225,15.0482359 9.24275,15.1573206 9.3305,15.242543 C9.414875,15.3277655 9.522875,15.3720811 9.6545,15.3720811 L12.80675,15.3720811 L12.80675,20.3695245 C12.80675,20.4922448 12.850625,20.5979206 12.938375,20.6899608 C13.026125,20.7785921 13.134125,20.8229078 13.255625,20.8229078 L15.955625,20.8229078 C16.077125,20.8229078 16.18175,20.7785921 16.272875,20.6899608 C16.364,20.6013295 16.4045,20.4922448 16.4045,20.3695245 L16.4045,15.3686722 L19.553375,15.3686722 C19.674875,15.3686722 19.7795,15.3243566 19.870625,15.2357252 C19.958375,15.1470939 20.00225,15.0380092 20.00225,14.9152889 C20.00225,14.7823419 19.96175,14.6732572 19.874,14.5880348 L14.922875,9.58718255 C14.8385,9.50196012 14.7305,9.45764445 14.598875,9.45764445 C14.46725,9.45764445 14.35925,9.49855122 14.274875,9.58718255 L9.344,14.5743992 C9.2495,14.6868928 9.20225,14.7993864 9.20225,14.9152889 L9.20225,14.9152889 Z" id="形状" fill="#4F7AFD"></path></g></g></g></g></g></g>
                </svg>
                <h3>上传填好的信息表</h3>
                <p>文件后缀名必须为xlsx,文件大小不得大于10M,最多支持导入10000条数据</p>
            </div>
            <div class="import-form">

                <a-upload :file-list="fileList" :remove="handleRemove" :before-upload="beforeUpload">
                    <a-button v-if="buttonshow"> <a-icon type="folder-open" /> 上传文件 </a-button>
                </a-upload>
                <a v-if="buttonshow" :href="url" download="线索导入模板.xls">下载数据模板</a>
            </div>
        </a-modal>

        <!-- 导出数据 -->
        <a-modal
            title="批量导出"
            :visible="exportvisible"
            :confirm-loading="confirmLoading"
            @ok="importOk"
            @cancel="handleCancel"
            :footer="null"
            >
            <div class="import-text">
                <a-spin :spinning="spinning">
                    <div class="export-content" >
                        <svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" style="width: 54px; height: 54px; margin-bottom: 12px;">
                            <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Artboard-Copy-83"><circle id="Oval-12" fill="#33B028" cx="27" cy="27" r="27"></circle><polyline id="Path-9" stroke="#FFFFFF" stroke-width="6" stroke-linecap="round" stroke-linejoin="round" points="14 28.6835304 22.5324773 37 41 19"></polyline></g></g>
                        </svg> 
                        <h4>批量导出已完成</h4>
                        <p>线索导出已完成,导出数据量{{totalnum}}条，下载导出文件。</p>
                        <a class="export-btn" :href="exporturl" download>
                            <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Icon-color-2"><rect id="矩形" x="0" y="0" width="20" height="20"></rect><circle id="椭圆形" fill="#4F7AFD" cx="10" cy="10" r="7"></circle><path d="M13.7874223,8.70748256 L10.6082602,6.24464133 C10.4561396,6.09636616 10.2413392,6 9.99995555,6 C9.75857185,6 9.54386039,6.09636616 9.39422917,6.24616557 L6.20991046,8.70570428 C6.08170594,8.83831359 6,9.0096218 6,9.19955966 C6,9.60729521 6.36647646,9.93788702 6.81821516,9.93788702 C6.82452759,9.93788702 6.8306622,9.93712489 6.83688572,9.93695553 L6.83688572,9.94161295 L8.66634397,9.94161295 L8.66634397,14 L11.3335671,14 L11.3335671,9.94161295 L13.1331525,9.94161295 L13.1331525,9.93568533 C13.1493336,9.93653213 13.1652481,9.93805638 13.1817848,9.93805638 C13.6336124,9.93805638 14,9.60737989 14,9.19955966 C14,9.0096218 13.9182052,8.83839827 13.7874223,8.70748256 Z" id="路径" fill="#FFFFFF" fill-rule="nonzero" transform="translate(10.000000, 10.000000) rotate(-180.000000) translate(-10.000000, -10.000000) "></path><rect id="矩形" fill="#4F7AFD" x="8" y="7" width="4" height="1"></rect></g></g>
                            </svg>
                            <span>下载导出文件</span>
                        </a>
                    </div>
                </a-spin>
            </div>
        </a-modal>


         <!-- 删除 -->
        <a-modal
        title="确认提示"
        :visible="delvisible"
        :confirm-loading="confirmLoading"
        @ok="delhandleOk"
        @cancel="handleCancel"
        width="420px"
        okText="确定"
        >
            <div class="delLog">
               <div>
                   <img src="../../../static/tip.png" alt="">
               </div>
               <div>是否确定删除对应的记录?</div>
            </div> 
        </a-modal>

        <!-- 写跟进 -->
        <a-modal
        title="新建跟进"
        :visible="gjvisible"
        :confirm-loading="confirmLoading"
        @ok="gjhandleOk"
        @cancel="handleCancel"
        width="610px"
        okText="保存"
        >
            <div class="followLog">
               <a-textarea v-model="gjcontent" placeholder="勤跟进,多签单" :rows="2" />
            </div>
        </a-modal>

    <!-- 拨打电话 -->
    <div class="communicate-body" v-if="callshow">
        <div>
            <div class="communicate-head">
                <a-dropdown>
                    <a class="ant-dropdown-link" >
                    <img src="../../../static/svg/drop.svg" alt="">
                    <span>五卡话机</span>
                    </a>
                    <a-menu slot="overlay">
                    <a-menu-item v-for="(item,i) in calltypelist" :key="i">{{item}}</a-menu-item>
                    </a-menu>
                </a-dropdown>

                <a-dropdown>
                    <div class="agent-status" style="width: 70px; margin-top: 1px;" >
                    SIM卡 {{currentsim}}<a-icon type="down" />
                    </div>
                    <a-menu slot="overlay"  @click="switchsim">
                    <a-menu-item v-for="(item,i) in simlist" :key="i+1" :disabled="item">
                        SIM卡{{i+1}}
                    </a-menu-item>
                    </a-menu>
                </a-dropdown>

                <div class="communicate-close"  @click="closecall">
                    <img src="../../../static/svg/close.svg" alt="">
                </div>

            </div>
        </div>

   

      <div class="communicate-body-oper">
        <div :style="{display:show1}" class="communicate-oper" id="success" >
            <div class="number-input">
                <img src="../../../static/svg/call.svg" alt="">
                <a-input autocomplete="off" v-model="phone" placeholder="请输入电话号码" style="font-size: 18px;"></a-input>
            </div>

            <div class="communicate-key">
                <div class="keyboard-box" >
                <span class="keyboard-btn" @click='handleKeyPress' data-num='1'>1</span>
                <span class="keyboard-btn" @click='handleKeyPress' data-num='2'>2</span>
                <span class="keyboard-btn" @click='handleKeyPress' data-num='3'>3</span>
                <span class="keyboard-btn" @click='handleKeyPress' data-num='4'>4</span>
                <span class="keyboard-btn" @click='handleKeyPress' data-num='5'>5</span>
                <span class="keyboard-btn" @click='handleKeyPress' data-num='6'>6</span>
                <span class="keyboard-btn" @click='handleKeyPress' data-num='7'>7</span>
                <span class="keyboard-btn" @click='handleKeyPress' data-num='8'>8</span>
                <span class="keyboard-btn" @click='handleKeyPress' data-num='9'>9</span>
                <span class="keyboard-btn" @click='handleKeyPress' data-num='*'>*</span>
                <span class="keyboard-btn" @click='handleKeyPress' data-num='0'>0</span>
                <span class="keyboard-btn" @click='handleKeyPress' data-num='#'>#</span>
                </div>

                <div class="communicate-call-btn" >
                <!-- <a-button type="primary">了解更多</a-button> -->
                <img src="../../../static/svg/down.svg"  @click="totel" alt="">
                <img class="totell" src="../../../static/svg/callbtn.svg"  @click="totel" alt="">
                <img src="../../../static/svg/delphone.svg"  @click="totel" alt="">
                <!-- <a-button @click="totel">拨打电话</a-button> -->
                </div>
            </div>
        </div>

        <div :style="{display:show2}" class="load-communicate" id="loading">
            <div class="divinputforcall-uncall">
                <img style="width: 16px; height: 16px;" src="../../../static/svg/down.svg"  @click="totel" alt="">
                <a-input style="font-size:18px" placeholder="请输入电话号码" autocomplete="off"></a-input>
                <img style="box-shadow: rgba(98, 205, 105, 0.6) 0px 0px 10px;border-radius: 50%;" src="../../../static/svg/tel2.svg"  @click="totel" alt="">
            </div>

            <div class="communicate-record">
                <div class="head-top">
                    <span>{{cluedetail.clue_name}}</span>
                    <div class="labelContainer">
                        <div v-if="cluedetail.tag.length>0">--</div>
                        <div v-else class="type-list"><span v-for="(item,idx) in cluedetail.tag" :key="idx">{{item}}</span></div>
                       
                    </div>
                    <a-dropdown :trigger="['click']" v-model="typevisible">
                        <span class="ant-dropdown-link add-type" @click="e => e.preventDefault()">
                            + 标签
                        </span>
                        <div slot="overlay" class="tags-panel">
                            <div class="tags-panel-title">设置标签</div>
                             <a-checkbox-group
                            v-model="value"
                            name="checkboxgroup"
                            :options="plainOptions"
                            @change="onChangetype"
                            />

                            <div class="btnContent">
                                <a-button size="small" click="handleMenuClick">取消</a-button>
                                <a-button size="small" @click="settag" type="primary">确定</a-button>
                            </div>
                        </div> 
                    </a-dropdown>

                    <a-textarea v-model="gjcontent" placeholder="勤写跟进，多赢单，限定500个字" :rows="4" />
                    <a-button  class="savephone" @click="gjhandleOk">保存</a-button>
                    
                </div>
            </div>
        </div>

        <div :style="{display:show3}" class="fail-communicate-oper" id="fail" >
            <img src="../../../static/svg/fail_work.svg" alt="" >
            <h1>目前话机无法正常工作，检查后重试</h1>
            <div>
              <p>1、检测话机是否正常运作，如断电、死机</p>
              <p>2、检测话机与电脑的连接是否正常，建议重新插拔USB设备，更换USB接口或数据线</p>
            </div>
        </div>

        <div :style="{display:show4}" class="exp" id="blockpage">
            <a-spin />
        </div>
      </div>

    </div>

    <!-- 设置筛选条件 -->
    <a-modal
      title="设置筛选条件"
      :visible="vsearch"
      :confirm-loading="confirmLoading"
      @ok="setsearch"
      @cancel="handleCancel"
    >
        <div>筛选条件不得少于5项，最多支持10个筛选条件</div>
        <div>
            <div class="custom-column-head">
                <div>显示</div>
                <div>筛选项</div>
                <div>拖动调整顺序</div>
            </div>
            <vuedraggable class="custom-column">
                <transition-group>
                    <div v-for="item in searchlist" :key="item.id" class="listWrap">
                        <a-checkbox :checked="item.status==1" @change="cselect"></a-checkbox>
                        <div>{{item.name}}</div>
                        <a-icon type="pause" :rotate="90"/>
                    </div>
                </transition-group>
            </vuedraggable>
        </div>
    </a-modal>

    <!-- 抽屉 -->
    <a-drawer
      placement="right"
      :closable="false"
      :visible="drawervisible"
      :after-visible-change="afterVisibleChange"
      @close="onClose"
      width="1024"
      class="tc"
    >
      <div class="company-content">
          <section class="left">
              <div class="top-info" v-if="companydetail">
                    <div class="company-info" style="background:#fff" >
                        <div class="lq-phone">
                            <a-button :loading="loading" type="primary" @click="receivephone(companydetail._source.id)">一键领取</a-button>
                        </div>
                        <div class="company-head">
                            <img src="../../../static/head.jpg" alt="">
                        </div>
                        <div class="info">
                            <h3>{{companydetail._source.name}} <span>{{companydetail._source.check_date}}更新</span></h3>
                            <section class="type">
                                <span>联系方式{{companydetail._source.total_contact_num}}个</span>
                                <span>{{companydetail._source.industry}}</span>
                                <span>{{companydetail._source.status}}</span>
                            </section>
                            <section class="cz">
                                <span>
                                    <span>法定代表:</span>
                                    <span>{{companydetail._source.legal}}</span>
                                    <span class="block"></span>
                                </span>
                                <span>
                                    <span>注册资本:</span>
                                    <span>{{companydetail._source.registermoney}}</span>
                                    <span class="block"></span>
                                </span>
                                <span>
                                    <span>成立日期:</span>
                                    <span>{{companydetail._source.create_date}}</span>
                                </span>
                            </section>
                            <section class="cz">
                                <span>
                                    <span>备案号:</span>
                                    <span>{{companydetail.icpinfo.icp}}</span>
                                    <span class="block"></span>
                                </span>
                                <span>
                                    <span>性质:</span>
                                    <span>{{companydetail.icpinfo.indurty}}</span>
                                    <span class="block"></span>
                                </span>
                                <span>
                                    <span>审核时间:</span>
                                    <span>{{companydetail.icpinfo.checktime}}</span>
                                    <span class="block"></span>
                                </span>
                                <!-- <span>
                                    <span>接入商:</span>
                                    <span>{{companydetail.icpinfo.servicename}}</span>
                                </span> -->
                            </section>
                            <p><span>地址：</span>{{companydetail._source.address}}</p>
                        </div>
                    </div>


                    <div class="all-info">
                        <a-tabs default-active-key="1">
                            <a-tab-pane key="1" tab="基本信息" v-if="companydetail">
                                <!-- <div class="s-menu">
                                    <span><a href="">企业简介</a></span>
                                    <span><a href="">工商信息</a></span>
                                    <span><a href="">股东信息1</a></span>
                                    <span><a href="">主要人员2</a></span>
                                    <span><a href="">工商变更2</a></span>
                                </div> -->

                                <div class="vistor-basic-info">
                                    <!-- <div class="info-extend">
                                        <div class="title"> 
                                            <span class="block"></span>
                                            <span class="font">企业简介</span>
                                            <span class="cz">收起<a-icon type="down" /></span>
                                        </div>
                                        <div class="content">
                                            <div class="text">
                                                <span>微盟是一家专门针对微信公众账号提供营销推广服务的第三方平台，主要功能是针对微信商家公众号提供与众不同的、有针对性的营销推广服务。上海晖硕信息科技有限公司旗下产品。</span>
                                            </div>
                                        </div>
                                    </div> -->

                                    <div class="info-extend">
                                        <div class="title">
                                            <span class="block"></span>
                                            <span class="font">工商信息</span>
                                            <span class="cz">收起<a-icon type="down" /></span>
                                        </div>
                                        <div class="content">
                                            <a-descriptions bordered :column="2">
                                                <a-descriptions-item label="统一社会信用代码">{{companydetail._source.creditcode}}</a-descriptions-item>
                                                <a-descriptions-item label="所属人">{{companydetail._source.legal}}</a-descriptions-item>
                                                <a-descriptions-item label="组织机构代码">{{companydetail._source.organizationcode}}</a-descriptions-item>
                                                <a-descriptions-item label="经营状态">{{companydetail._source.status}}</a-descriptions-item>
                                                <a-descriptions-item label="法定代表人">{{companydetail._source.legal}}</a-descriptions-item>
                                                <a-descriptions-item label="注册资本">{{companydetail._source.registermoney}}</a-descriptions-item>
                                                <a-descriptions-item label="公司类型">{{companydetail._source.companytype}}</a-descriptions-item>
                                                <a-descriptions-item label="成立日期">{{companydetail._source.create_date}}</a-descriptions-item>
                                                <a-descriptions-item label="营业期限">--</a-descriptions-item>
                                                <a-descriptions-item label="登记机关">--</a-descriptions-item>
                                                <a-descriptions-item label="核准日期">{{companydetail._source.check_date}}</a-descriptions-item>
                                                <a-descriptions-item label="公司规模">{{companydetail._source.insurancenum}}</a-descriptions-item>
                                                <a-descriptions-item label="纳税人识别号">{{companydetail._source.taxpayernum}}</a-descriptions-item>
                                                <a-descriptions-item label="所属行业">{{companydetail._source.industry}}</a-descriptions-item>
                                                <a-descriptions-item :span="3" label="曾用名">{{companydetail._source.oldname}}</a-descriptions-item>
                                                <a-descriptions-item :span="3" label="企业地址">{{companydetail._source.address}}</a-descriptions-item>
                                                <a-descriptions-item :span="3" label="经营范围">{{companydetail._source.scope}}</a-descriptions-item>
                                            </a-descriptions>
                                        </div>
                                    </div>

                                    <!-- <div class="info-extend">
                                        <div class="title">
                                            <span class="block"></span>
                                            <span class="font">股东信息</span>
                                            <span class="cz">收起<a-icon type="down" /></span>
                                        </div>
                                        <div class="content gdinfo">
                                            <section>
                                                <div class="name">苏州工业园区八二五新媒体投资企业（有限合伙）</div>
                                                <p>持股比例：4.362%</p>
                                                <p>认缴出资日期：--</p>
                                                <p>认缴出资额：274.9442万元</p>
                                            </section>

                                            <section>
                                                <div class="name">苏州工业园区八二五新媒体投资企业（有限合伙）</div>
                                                <p>持股比例：4.362%</p>
                                                <p>认缴出资日期：--</p>
                                                <p>认缴出资额：274.9442万元</p>
                                            </section>
                                        </div>
                                    </div>

                                    <div class="info-extend">
                                        <div class="title">
                                            <span class="block"></span>
                                            <span class="font">主要人员</span>
                                            <span class="cz">收起<a-icon type="down" /></span>
                                        </div>
                                        <div class="content mainpeople">
                                            <section>
                                                <div>
                                                    <img src="../../../static/head.png" alt="">
                                                </div>
                                                <div class="info">
                                                    <p>刘志平</p>
                                                    <p>执行董事兼总经理</p>
                                                </div>
                                            </section>
                                        </div>
                                    </div>

                                    <div class="info-extend">
                                        <div class="title">
                                            <span class="block"></span>
                                            <span class="font">工商变更</span>
                                            <span class="cz">收起<a-icon type="down" /></span>
                                        </div>
                                        <div class="content">
                                            <div class="informationRight" style="padding-left:0;margin-left:0">
                                                <div class="basicinfo">
                                                    <a-timeline>
                                                        <a-timeline-item>
                                                            <span slot="dot" class="steps-index-TimeDot"></span>
                                                            <div class="date-arrow">10/20</div>
                                                        </a-timeline-item>
                                                        <a-timeline-item>
                                                            <div class="description">
                                                                <div class="dataContainer">
                                                                    <span class="follow-title">电话呼出</span>
                                                                    <span class="follow-date"><a-icon type="clock-circle"/>10/20 17:03</span>

                                                                    <div><p>接通状态：已接听</p></div>
                                                                    <div><p>通话对象：万先生</p></div>
                                                                    <div class="RecordingAudio">

                                                                    </div>

                                                                    <div><p>来自客户：<a href="JavaScript:;">万先生</a></p></div>
                                                                    <div class="cz-user"><span>操作人：程先生</span></div>
                                                                </div>

                                                            
                                                            </div>
                                                        </a-timeline-item>
                                                        <a-timeline-item>Technical testing 2015-09-01</a-timeline-item>
                                                        <a-timeline-item>Network problems being solved 2015-09-01</a-timeline-item>
                                                    </a-timeline>
                                                </div>
                                            </div>
                                        </div>
                                    </div> -->

                                </div>

                            </a-tab-pane>
                            <!-- <a-tab-pane key="2" tab="经营状况" force-render disabled>
                                 <div class="s-menu">
                                    <span><a href="">企业动态</a></span>
                                    <span><a href="">融资历史</a></span>
                                    <span><a href="">招投标</a></span>
                                </div>

                                <div class="vistor-basic-info">
                                    <div class="info-extend">
                                        <div class="title">
                                            <span class="block"></span>
                                            <span class="font">融资历史</span>
                                            <span class="cz">收起<a-icon type="down" /></span>
                                        </div>
                                        <div class="content">
                                            <div class="informationRight" style="padding-left:0;margin-left:0">
                                                <div class="basicinfo">
                                                    <a-timeline>
                                                        <a-timeline-item>
                                                            <span slot="dot" class="steps-index-TimeDot"></span>
                                                            <div class="date-arrow">10/20</div>
                                                        </a-timeline-item>
                                                        <a-timeline-item>
                                                            <div class="description">
                                                                <div class="dataContainer">
                                                                    <span class="follow-title">电话呼出</span>
                                                                    <span class="follow-date"><a-icon type="clock-circle"/>10/20 17:03</span>

                                                                    <div><p>接通状态：已接听</p></div>
                                                                    <div><p>通话对象：万先生</p></div>
                                                                    <div class="RecordingAudio">

                                                                    </div>

                                                                    <div><p>来自客户：<a href="JavaScript:;">万先生</a></p></div>
                                                                    <div class="cz-user"><span>操作人：程先生</span></div>
                                                                </div>

                                                            
                                                            </div>
                                                        </a-timeline-item>
                                                        <a-timeline-item>Technical testing 2015-09-01</a-timeline-item>
                                                        <a-timeline-item>Network problems being solved 2015-09-01</a-timeline-item>
                                                    </a-timeline>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </a-tab-pane>
                            <a-tab-pane key="3" tab="招聘信息" disabled>
                                <div class="s-menu">
                                    <span><a href="">招聘情况</a></span>
                                    <span><a href="">招聘岗位</a></span>
                                </div>

                                <div class="vistor-basic-info">
                                    <div class="info-extend">
                                        <div class="title">
                                            <span class="block"></span>
                                            <span class="font">招聘情况</span>
                                            <span class="cz">收起<a-icon type="down" /></span>
                                        </div>
                                        <div class="content">
                                            <a-descriptions bordered :column="2">
                                                <a-descriptions-item label="招聘渠道">6(看准网、职友集、其他、百度招聘、BOSS直聘、58同城)</a-descriptions-item>
                                                <a-descriptions-item label="岗位业务关键词">BD、运营、店长、项目、前端、公关、金融、商务、招聘、视觉、采购、人事、视频、推广、高级、客户、培训、广告、客服、法务、Java、行政、技术、网络、测试、人力、架构师、营销、文案、数据、媒介、产品、研发、市场、编辑、安全、运维、物流、新媒体、销售、审核</a-descriptions-item>
                                                <a-descriptions-item label="岗位职级关键词	">其他</a-descriptions-item>
                                                <a-descriptions-item label="当前招聘岗位数	">--</a-descriptions-item>
                                                <a-descriptions-item label="当前招聘人数">跟进中</a-descriptions-item>
                                                <a-descriptions-item label="平均薪资">--</a-descriptions-item>
                                                <a-descriptions-item :span="3" label="招聘城市">--</a-descriptions-item>
                                            </a-descriptions>
                                        </div>
                                    </div>
                                </div>

                                <div class="vistor-basic-info">
                                    <div class="info-extend">
                                        <div class="title">
                                            <span class="block"></span>
                                            <span class="font">招聘岗位</span>
                                            <span class="cz">收起<a-icon type="down" /></span>
                                        </div>
                                        <div class="content zpgw">
                                             <section>
                                                <div class="name">媒介采购J10391</div>
                                                <p>招聘城市：上海市</p>
                                                <p>平均薪资：￥7000-13000</p>
                                                <p>招聘渠道：看准网</p>
                                                <p>发布时间：2017-11-19</p>
                                            </section>
                                        </div>
                                    </div>
                                </div>
                            </a-tab-pane>
                            <a-tab-pane key="4" tab="媒体信息" disabled>
                                 <div class="s-menu">
                                    <span><a href="">官方网站</a></span>
                                    <span><a href="">网络推广</a></span>
                                    <span><a href="">公众号 11</a></span>
                                    <span><a href="">微博 4</a></span>
                                </div>
                                <div class="vistor-basic-info">
                                    <div class="info-extend">
                                        <div class="title">
                                            <span class="block"></span>
                                            <span class="font">官方网站</span>
                                            <span class="cz">收起<a-icon type="down" /></span>
                                        </div>
                                        <div class="content office">
                                             <section>
                                                <div class="name">www.weiwin.net</div>
                                                <p>官网名称：上海微盟科技股份有限公司</p>
                                                <p>备案号：沪ICP备17019238号-2</p>
                                                <p>审核时间：2017-06-14网</p>
                                            </section>
                                        </div>
                                    </div>
                                </div>
                            </a-tab-pane>
                            <a-tab-pane key="5" tab="产品信息" force-render disabled>
                                
                            </a-tab-pane>
                            <a-tab-pane key="6" tab="知识产权" disabled>
                                <div class="s-menu">
                                    <span><a href="">商标信息 6</a></span>
                                    <span><a href="">专利信息 0</a></span>
                                </div>
                                <div class="vistor-basic-info">
                                    <div class="info-extend">
                                        <div class="title">
                                            <span class="block"></span>
                                            <span class="font">商标信息</span>
                                            <span class="cz">收起<a-icon type="down" /></span>
                                        </div>
                                        <div class="content sbinfo">
                                            <section>

                                                <p>商标类别：35 - 广告销售</p>
                                                <p>申请时间：2013-05-31</p>
                                            </section>
                                        </div>
                                    </div>
                                </div>
                            </a-tab-pane> -->
                        </a-tabs>

                    </div>
              </div>
        </section>
        <section class="right" v-if="companydetail">
            <div>
                <section class="company-phone-tabs">
                    <section class="phone-index-top-info">
                        <div class="company-phone-index-left">
                            <span>联系方式</span>
                            <a-popover placement="bottomRight">
                                <template slot="content">
                                    <p style="width:210px">所有信息均来自互联网公开数据，如您认为有侵犯到您的个人信息或隐私，请联系客服进行处理。</p>
                                </template>
                                <a-icon type="info-circle" />
                            </a-popover>
                        </div>
                    </section>
                    <a-divider />
                    <section class="phone-index-source-type">
                        <span @click="switchphone(0,companydetail.icpinfo.id)" :class="{phonetype:0==current}">全部({{companydetail._source.total_mobile_num+companydetail._source.total_tel_num}})</span>
                        <span @click="switchphone(1,companydetail.icpinfo.id)" :class="{phonetype:1==current}">手机({{companydetail._source.total_mobile_num}})</span>
                        <span @click="switchphone(2,companydetail.icpinfo.id)"  :class="{phonetype:2==current}">固话({{companydetail._source.total_tel_num}})</span>
                    </section>
                </section>
            </div>
            <div>
                <div class="phone-card-item">
                    <div class="phone-index-phone" v-for="(item,i) in phone_list" :key="i">
                        <p>{{item}}</p>
                    </div>
                    <div class="item-receive-status">
                        <a-button :loading="loading" @click="receivephone(companydetail._source.id)">立即领取</a-button>
                    </div>

                </div>
                
            </div>
            <!-- <a-tabs default-active-key="1" >
                <a-tab-pane key="1" tab="手机">
                </a-tab-pane>
                <a-tab-pane key="2" tab="固话" force-render>
                </a-tab-pane>
                <a-tab-pane key="3" tab="邮箱">
                </a-tab-pane>
            </a-tabs>

            <div class="getPhone">
                <section>
                    <a-checkbox :indeterminate="indeterminate" :checked="checkAll" @change="onCheckAllChange">全选</a-checkbox>
                    <a-button size="small" icon="import">领取</a-button>
                </section>

                <div class="phoneCard phone-active">
                    <div class="content ">
                        <div class="phone"><span>130****0783</span></div>
                        <div class="name"><span>姓名：孙**</span></div>
                        <div class="type">
                            <span>黄页</span>
                        </div>
                    </div>
                </div>

                 <div class="phoneCard">
                    <div class="content ">
                        <div class="phone"><span>130****0783</span></div>
                        <div class="name"><span>姓名：孙**</span></div>
                        <div class="type">
                            <span>黄页</span>
                        </div>
                    </div>
                </div>
            </div> -->
        </section>
      </div>
    </a-drawer>


    </div>
</template>
<style>
::-webkit-scrollbar-thumb  {
    background: #d8d8d8 !important;
    box-shadow: none
}
::-webkit-scrollbar-track {
    background   : #fff;
    box-shadow: none
}
.ant-tooltip{
    background-color: transparent;
    box-shadow: none !important;
    background-clip: padding-box;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0,0,0,.15);
}
.ant-tooltip p{
    font-size: 12px;
    color: #666;
    text-align: left;
    line-height: 20px;
}
.ant-tooltip-inner{background: #fff}
.ant-tooltip-arrow::before{background: #fff}
</style>
<script>

const columns = [
  {
    title: 'ID',
    dataIndex: '_source.id',
    key: '_source.id',
    width:'80px'
  },

  {
    title: '单位名称',
    key: '_source.company',
    dataIndex: '_source.company',
    scopedSlots: { customRender: 'name' },
    width:'110px'
  },
    {
    title: '单位性质',
    key: '_source.indurty',
    dataIndex: '_source.indurty',

  },
  {
    title: '域名',
    dataIndex: '_source.website',
    key: '_source.website',

  },
  {
    title: '网站备案/许可证号',
    dataIndex: '_source.icp',
    key: '_source.icp',
  },
   {
    title: '网站名称',
    dataIndex: '_source.webname',
    key: '_source.webname',
    scopedSlots: { customRender: 'mobile_phone' },

  },
  {
    title: '网站首页网址',
    dataIndex: '_source.indexsite',
    key: '_source.indexsite',

  },
  {
    title: '审核时间',
    dataIndex: '_source.checktime',
    key: '_source.checktime',

  },
   {
    title: '接入商',
    dataIndex: '_source.servicename',
    key: '_source.servicename',

  },
  {
    title: '状态',
    dataIndex: '_source.status',
    key: '_source.status',

  }
];

const rowSelection = {
  onChange: (selectedRowKeys, selectedRows) => {
    console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
  },
  onSelect: (record, selected, selectedRows) => {
    console.log(record, selected, selectedRows);
  },
  onSelectAll: (selected, selectedRows, changeRows) => {
    console.log(selected, selectedRows, changeRows);
  },
};
import vuedraggable from 'vuedraggable';
import { Modal } from 'ant-design-vue';
export default {
    components: {vuedraggable},
    data(){
        return{
            drawervisible:false,
            pageSizeOptions:['10','20','30','40','100','200'],
            select1:false,
            select2:true,
            cc1:false,
            cc2:true,
            cc3:true,
            show:false,
            tstext:"高级搜索",
            data:[],
            columns,
            rowSelection,
            visible:false,
            sourceObj:"",
            targetObj:"",
            pagination:{},
            currentpagination:"",
            selectedRowKeys: [],
            bgvisible:false,
            confirmLoading:false,
            bglist:"",
            bgid:"",
            importvisible:false,
            exportvisible:false,
            fileList:[],
            uploading: false,
            file:{},
            buttonshow:true,
            spinning:true,
            url:"",
            exporturl:"",
            exportload:true,
            fqvisible:false,
            reason:"",
            cause_of_abandonment:"",
            blaclist:"",
            delvisible:false,
            delid:"",
            delids:[],
            bgclueid:"",
            fqid:"",
            gjclueid:"",
            gjcontent:"",
            gjvisible:false,
            tablespinning:true,
            searchtext:"",
            size:10,
            currentpage:"",
            pageshow:false,
            totalpage:"",
            windowHeight: document.documentElement.clientHeight,   //实时屏幕高度
            tabley:"",


            menulist:"",
            userinfo:"",
            search:"",
            phone:"",
            callshow:false,
            cluedetail:"",
            plainOptions:[],
            tags:[],
            phoneid:"",
            typevisible:false,
            value: [],

            show1:'none',
            show2:'none',
            show3:'none',
            show4:'block',

            totalnum:"",

            searchlist:{
                status:""
            },
            current:0,
            vsearch:false,
            dxlist:{
                call_type:[],
                tag:[],
                information_source:[],
                follow_status:[],
                clue_source:[],
                gender:[],
                industry_type:[],
                enterprise_scale:[],
                position:[],
                owner:[],
                create_user_wid:[],
                last_update_user_wid:[],
                last_follow_user_wid:[],
                cause_of_abandonment:[],
                clue_status:[]
            },
            xzlist:{},
            searcharr:[],
            datelist:['昨天','今天','上周','本周','上月','本月','本季','本年'],
            datecurrent:"",
            addressoptions:[],

            simlist:[],
            currentsim:"",
            calltypelist:"",


            groupvisible:false,
            editgroupvisible:false,
            groupdetail:"",
            groupname:'',
            groupsort:"",
            grouplist:"",
            editgroupid:"",
            searchgroupname:"",
            groupnum:0,
            groupcurrent:0,
            groupid:"",
            setgroupid:"",
            setgroupvisible:false,
            groupwidth:"165px",
            groupleft:'10px',
            sgshow:true,
            zkshow:false,

            companydetail:"",
            phone_list:"",
            addressvalue:"",

            website:"",
            websitehz:"",

            loading:false,
            dwxz:""
            
        }
    },
    watch: {
      windowHeight (val) {
        this.tabley=val*0.56
      },
    },
    mounted(){
        // 地址
        this.$axios.get('/api/getareabypid',{
            headers: {
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            }
        }).then((res)=>{
            if(res.data.code==200){
                res.data.data.forEach(item => {
                    this.$set(item,'isLeaf',false)

                })
                this.addressoptions=res.data.data

            }
        })
        // 获取拨打方式
        this.$axios.get("/api/getcalltype",{
        headers: {
            "appid": this.appSet.appid,
            "appkey": this.appSet.appkey,
            "token":localStorage.getItem('token'),
        },
        }).then((res)=>{
            if(res.data.code==200){
            this.calltypelist=res.data.data
            }else{
                this.$message.error(res.data.msg);
            }
        }),


        window.fullHeight = document.documentElement.clientHeight;
        this.windowHeight = window.fullHeight;  
        this.tabley=this.windowHeight*0.56
         // <!--把window.onresize事件挂在到mounted函数上-->
        window.onresize = () => {
            return (() => {
                window.fullHeight = document.documentElement.clientHeight;
                this.windowHeight = window.fullHeight;  // 高
                this.tabley=this.windowHeight*0.56
                console.log("实时屏幕高度：",this.tabley);
            })()
        };
        this.fetch()
        // 搜索条件
        this.$axios.get("/api/datasearch",{
            headers: {
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            }
        }).then((res)=>{
            if(res.data.code==200){
                this.searchlist=res.data.data
            }
        }),

        // 所属人列表
        this.$axios.get("/api/userlist",{
            headers: {
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            }
        }).then((res)=>{
            if(res.data.code==200){
                this.bglist=res.data.data.lists
            }
        }),
        // 标签列表
        this.$axios.get("/api/getdatatags",{
            headers: {
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            },
        }).then((res)=>{
            if(res.data.code==200){
                this.plainOptions=res.data.data
            }else{
                this.$message.error(res.data.msg);
            }
        }),

        // 下载模板
        this.$axios.get("/api/getdataexcel",{
            headers: {
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            }
        }).then((res)=>{
            if(res.data.code==200){
                this.url=res.data.data.downloadurl
            }
        }),
        
        // 放弃原因
        this.$axios.get("/api/dropreason",{
            headers: {
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            }
        }).then((res)=>{
            if(res.data.code==200){
                this.reason=res.data.data
            }
        })

        // this.getgrouplist()

    },
    methods:{
    inputFunction(){
        this.fetch()
    },
    handleChangeweb(value){
        this.websitehz=value
        this.fetch()
    },
    // 单位性质
    handleChangexz(value){
        this.dwxz=value
        this.fetch()
    },
    //   领取电话
    receivephone(value){
        this.loading=true
        this.$axios.get("/api/receiveqcc",{
            headers: {
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            },
            params:{
                id:value
            }
        }).then((res)=>{
            if(res.data.code==200){
                this.loading=false
                this.$message.success(res.data.msg);       
            }else{
                this.$message.error(res.data.msg);
            }
        })
    },
    // 抽屉
    showDrawer(value) {
        this.$axios.get("/api/getjzhkdetail",{
            headers: {
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            },
            params:{
                id:value
            }
        }).then((res)=>{
            if(res.data.code==200){
                  var all=[]

                if(res.data.data._source.phone_list!=undefined&&res.data.data._source.tel_list!=undefined){
                    all=res.data.data._source.phone_total
                }else if(res.data.data._source.phone_list==undefined&&res.data.data._source.tel_list!=undefined){
                    all=res.data.data._source.tel_list
                }else if(res.data.data._source.phone_list!=undefined&&res.data.data._source.tel_list==undefined){
                    all=res.data.data._source.phone_list
                }
                for(var i in all){
                    all[i]=all[i].substr(0,3)+'****'+all[i].substr(7);
                }

                this.drawervisible = true;
                this.companydetail=res.data.data
                this.phone_list=all
            }else{
                this.$message.error(res.data.msg); 
            }
        })
    },
        onClose(){
            this.drawervisible=false
        },
        // showdrawer(){
        //     // alert(1)
        //     this.drawervisible=true
        // },

        lxhandleChange(value){
            this.dxlist.call_type=value
            this.fetch()
        },
        typehandleChange(value){
            this.dxlist.tag=value
            this.fetch()
        },
        lrhandleChange(value){
           this.dxlist.information_source=value
           this.fetch()
        },
        gjhandleChange(value){
            this.dxlist.follow_status=value
            this.fetch()
        },

        // 删除已选条件
        delsearch(a,b,c){
            this.searcharr=this.searcharr.filter(function (ele){return ele != a;});
            this.dxlist[b]=this.dxlist[b].filter(function (ele){return ele != c;});
            this.fetch()
        },
        deldxsearch(value){
            this.xzlist[value]=""
            this.fetch()
        },
        onChange(value){
           this.value=value
        },
        onChangeaddress(value){
            this.addressvalue=value
            this.fetch()
        },
        loadData(selectedOptions) {
            const targetOption = selectedOptions[selectedOptions.length - 1];
            var id;
            if(this.addressvalue.length==1){
                id=this.addressvalue[0]
            }else{
                id=this.addressvalue[1]
            }
            this.$axios.get('/api/getareabypid',{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    pid:id
                }
            }).then((res)=>{
                if(res.data.code==200){
                    if(this.value.length==1){
                        res.data.data.forEach(item => {
                        this.$set(item,'isLeaf',false)
                        })
                    }
                    targetOption.children = res.data.data
                    this.addressoptions = [...this.addressoptions];
                }
            })
        },
        changdate(value,event){
            var startime = value[0].format('YYYY-MM-DD')
            var endtime = value[1].format('YYYY-MM-DD')
            this.xzlist[event]=startime+'~'+endtime
            this.fetch()
        },
        // 选择日期
        searchdate(a,b,c){
            this.xzlist[a]=b,
            this.datecurrent=c
            this.fetch()
        },
        switchsim(e) {
            changesim(e.key)
            var qkstatus=switchstatus()
            if(qkstatus==1){
                this.currentsim=e.key
                this.$message.success("SIM"+e.key+'切卡成功');
            }else{
                this.$message.error("切卡失败")
            }
        },
        
        rselected(a,b,c){
            this.xzlist[a]=b
            // alert(this.xzlist[a])
            this.current=c;
            this.fetch()
        },
        cselected(a,b,c){
            // alert(a)
             if(this.searcharr.includes(a)){
                //includes()方法判断是否包含某一元素,返回true或false表示是否包含元素，对NaN一样有效
                //filter()方法用于把Array的某些元素过滤掉，filter()把传入的函数依次作用于每个元素，然后根据返回值是true还是false决定保留还是丢弃该元素：生成新的数组
                this.searcharr=this.searcharr.filter(function (ele){return ele != a;});
                this.dxlist[b]=this.dxlist[b].filter(function (ele){return ele != c;});
            }else{
                this.searcharr.push(a);
                this.dxlist[b].push(c)
            }
            this.fetch()
            console.log(this.xzlist[b])
        },
        cselect(){
            if(this.searchlist.status=1){
                this.searchlist.status=2
            }else{
                this.searchlist.status=1
            }
            
        },

        // 设置筛选条件
        setxmodal(){
            this.vsearch=true
        },
        setsearch(){

        },
         // 设置标签
        handleMenuClick(){
            this.typevisible=false
        },
        onChangetype(checkedValues) {
            this.tags=checkedValues
        },
        settag(){
            this.$axios.get("/api/setdatatags",{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    data_id:this.phoneid,
                    tag:this.tags
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.$message.success(res.data.msg);
                    this.$axios.get("/api/getdatatags",{
                        headers: {
                            "appid": this.appSet.appid,
                            "appkey": this.appSet.appkey,
                            "token":localStorage.getItem('token'),
                        },
                    }).then((res)=>{
                        if(res.data.code==200){
                            this.plainOptions=res.data.data
                        }else{
                            this.$message.error(res.data.msg);
                        }
                    })
                }else{
                    this.$message.error(res.data.msg);
                }
            })
        },

        //处理按键
        handleKeyPress(e) {
            let num = e.target.dataset.num;
            this.phone=this.phone+num
        },
        call(event,value){
             var simStatus= simlist()
            var nowsim=currsim()  
                if(simStatus!=undefined){
                simStatus=simStatus.split(",")
                }

            for(var i in simStatus){
            if(simStatus[i]==0){
                this.simlist[i]=true
            }else{
                this.simlist[i]=false
            }
            } 
            this.currentsim=nowsim

            this.phoneid=event.currentTarget.id
            var id=event.currentTarget.id
            this.callshow=!this.callshow,
            this.phone=value
            var link=linktype()
            if(link==2){
                // alert(link)
                this.show2='none'
                this.show1='none'
                this.show3='block'
                this.show4='none'
            }else{
                callfixed(id,1,value)
                this.show4='none'
                this.show1='none'
                this.show3='none'
                this.show2='block'

                this.$axios.get("/api/getdatadetail",{
                    headers: {
                        "appid": this.appSet.appid,
                        "appkey": this.appSet.appkey,
                        "token":localStorage.getItem('token'),
                    },
                    params:{
                        id:id,
                    }
                }).then((res)=>{
                    if(res.data.code==200){
                        this.cluedetail=res.data.data.info
                    }else{
                        this.$message.error(res.data.msg);
                    }
                })
            }
            

        },
        total(){

        },
        
        closecall(){
            this.callshow=false
        },
        onShowSizeChange(current,pageSize){
            this.size=pageSize
            // alert(pageSize)
            this.fetch();
        },
        handleTableChange(pageNumber) {
            this.currentpage=pageNumber
            this.fetch();
        },

        fetch(params = {}) {
            // this.loading = true;
            var w=this.website+this.websitehz
            var city=""
            if(this.addressvalue.length==2){
                city=this.addressvalue[1]
            }
            // console.log(this.xzlist)
            this.$axios.post('/api/getjzhklist',{
                limits: this.size,
                page:this.currentpage,
                name:this.searchtext,
                website:w,
                indurty:this.dwxz,
                province:this.addressvalue[0],
                city:city

            },{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },

            }).then((res)=>{
                if(res.data.code==200){
                    this.tablespinning=false
                    const pagination = { ...this.pagination };
                    pagination.total = res.data.data.count;
                    pagination.pageSize=this.size
                    this.data=res.data.data.lists
                    this.pagination = pagination;
                    this.totalpage=Math.ceil(res.data.data.count/this.size)
                }else if(res.data.code==300){
                    this.$router.push({path: '/'})
                }else if(res.data.code==401){
                    this.$message.warning(res.data.msg); 
                }else{
                    this.$message.warning(res.data.msg); 
                }
            })
        },
        // 转客户
        tokh(event){
            var id=event.currentTarget.id
            this.$router.push({path: '/cluetokh',query:{ id:id}});
        },
        // 写跟进
        showgj(event){
            this.gjclueid=event.currentTarget.id
            this.gjvisible=true
        },
        // 跟进
        gjhandleOk(){
            this.$axios.get("/api/addfollow",{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    content:this.gjcontent,
                    data_id:this.gjclueid,
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.gjvisible=false
                    this.$message.success(res.data.msg); 
                }else{
                    this.$message.error(res.data.msg); 
                }
            })
        },

        // 编辑
        editclue(event){
            var id=event.currentTarget.id
            this.$router.push({path: '/edit',query:{ id:id}});
        },
        // 删除
        delmodal(){
            this.delvisible=true
        },
        delmodal2(event){
            this.delid=event.currentTarget.id
            this.delvisible=true
        },
                
        delhandleOk(){
            if(this.delid!=""){
                this.selectedRowKeys.push(this.delid)
            }
            console.log(this.selectedRowKeys[0])
            this.$axios.post("/api/deldata",{
                'ids':this.selectedRowKeys
            },{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
            }).then((res)=>{
                if(res.data.code==200){
                    this.delvisible=false
                    this.$message.success(res.data.msg); 
                    this.fetch()
                }else{
                    this.$message.error(res.data.msg); 
                }
            })
        },

        // 导出
        exportmodal(){
            this.exportvisible=true
            this.$axios.get("/api/exportdata",{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.spinning=false
                    // this.exportload=false
                    this.totalnum=res.data.data.total
                    this.exporturl=res.data.data.downloadurl
                }
            })
        },

        // 批量导出
        plexportmodal(){
            this.exportvisible=true
            this.$axios.post("/api/batchexport",{
                ids:this.selectedRowKeys,
                type:1
            },{
            headers: {
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            }
            }).then((res)=>{
                if(res.data.code==200){
                    this.spinning=false
                    // this.exportload=false
                    this.totalnum=res.data.data.total
                    this.exporturl=res.data.data.downloadurl
                }
            })
        },
       
        // 导入数据
        importmodal(){
            this.importvisible=true
        },
        handleRemove(file) {
            const index = this.fileList.indexOf(file);
            const newFileList = this.fileList.slice();
            newFileList.splice(index, 1);
            this.fileList = newFileList;
            this.buttonshow=true
        },
        beforeUpload(file) {
            this.fileList = [...this.fileList, file]
            // console.log(this.fileList)
            // console.log("文件="+JSON.stringify(this.fileList))
            // this.file=this.fileList[0]
            this.buttonshow=false
            return false;
        },
        importOk(){
            var formData = new FormData();
            console.log(this.fileList[0])
            var file=this.fileList[0]
            console.log(file)
            formData.append('file',file)
            console.log(formData)
            this.$axios.post("/api/importdata",formData,{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    'Content-Type':'multipart/form-data',
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.$message.success(res.data.msg); 
                    this.importvisible=false
                    this.fetch()
                }else{
                   this.$message.error(res.data.msg);  
                }
            })
        },

        handleCancel(){
            this.bgvisible=false
            this.importvisible=false
            this.exportvisible=false
            this.fqvisible=false
            this.delvisible=false
            this.gjvisible=false
            this.vsearch=false

            this.groupvisible=false
            this.editgroupvisible=false
            this.setgroupvisible=false

            this.drawervisible=false
        },
        //   切换
        switchphone(value,id){
            this.current=value
            this.$axios.get("/api/getjzhkdetail",{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    id:id
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.visible = true;
                    this.companydetail=res.data.data
                    var all=[]
                    if(res.data.data._source.phone_list!=undefined&&res.data.data._source.tel_list!=undefined){
                        all=res.data.data._source.phone_total
                    }else if(res.data.data._source.phone_list==undefined&&res.data.data._source.tel_list!=undefined){
                        all=res.data.data._source.tel_list
                    }else if(res.data.data._source.phone_list!=undefined&&res.data.data._source.tel_list==undefined){
                        all=res.data.data._source.phone_list
                    }

                    for(var i in all){
                        all[i]=all[i].substr(0,3)+'****'+all[i].substr(7);
                    }
                    var phonelist=res.data.data._source.phone_list
                    var tellist=res.data.data._source.tel_list
                    for(var i in phonelist){
                        phonelist[i]=phonelist[i].substr(0,3)+'****'+phonelist[i].substr(7);
                    }
                    for(var i in tellist){
                        tellist[i]=tellist[i].substr(0,3)+'****'+tellist[i].substr(7);
                    }

                    if(value==1){
                        this.phone_list=phonelist
                    }else if(value==2){
                        this.phone_list=tellist
                    }else if(value==0){
                        this.phone_list=all
                    }
    
                }else{
                    this.$message.error(res.data.msg); 
                }
            })
        },
        //放弃
        fqmodal(){
            this.fqvisible=true
        },
        fqmodal2(event){
            this.fqvisible=true
            this.fqid=event.currentTarget.id
        },
        fqreason(value){
            this.cause_of_abandonment=value
        },
        fqhandleOk(){

             if(this.fqid!=""){
                 this.selectedRowKeys.push(this.fqid)
            }
            this.$axios.post("/api/dropdata",{
                'ids':this.selectedRowKeys,
                'cause_of_abandonment':this.cause_of_abandonment
            },{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.fqvisible=false
                    this.$message.success(res.data.msg);
                    this.fetch()
                }else{
                    this.$message.error(res.data.msg);
                }
            })
        },
        // 变更所属人
        showbg(){
            this.bgvisible=true
        },
        showbg2(event){
            this.bgclueid=event.currentTarget.id
            this.bgvisible=true
        },
        bghandleChange(value){
            this.bgid=value
        },
        bghandleOk(){
            var ids;
            if(this.selectedRowKeys.length==1){
                ids=this.selectedRowKeys[0]
            }else if(this.selectedRowKeys.length>1){
                ids=this.selectedRowKeys.join(','); 
            }
            if(ids==""){
                if(this.bgclueid!=""){
                    ids=this.bgclueid
                }
            }else{
                if(this.bgclueid!=""){
                    ids=ids+','+this.bgclueid
                }
            }
            // alert(ids)
            this.$axios.get("/api/setdatabelong",{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    ids:ids,
                    user_id:this.bgid
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.bgvisible=false
                    this.$message.success(res.data.msg); 
                    this.fetch()
                }else{
                    this.$message.error(res.data.msg); 
                }
            })
        },

        onSelectChange(selectedRowKeys) {
            console.log('selectedRowKeys changed: ', selectedRowKeys);
            this.selectedRowKeys = selectedRowKeys;
            if(selectedRowKeys.length==0){
                this.cc3=true
                this.cc1=false
            }else if(selectedRowKeys.length>0){
                this.cc3=false
                this.cc1=true
            }
        },
        
        ccsearch(){
           
        },
        closecc(){
            this.cc1=false,
            this.cc2=true
        },
        handleChange(value) {
            console.log(`selected ${value}`);
        },
        handleStatus(value) {
            console.log(`selected ${value}`);
        },
        handleserach(){

        },
        handleOk(){

        },
        onChange(e){

        },
        showcc(){
             this.cc1=true,
            this.cc2=false
        },
        editlist(){
            this.visible=true
        },
        showsx(){
            this.select2=false,
            this.select1=true
        },
        setsx(){
            this.select1=false,
            this.select2=true
        },
        onSearch(){
            this.fetch()
        },

        // 拖动排序
        customRow(record, index) {
            return {
                // FIXME: draggable： true 不生效还不晓得是什么原因，先使用鼠标移入事件设置目标行的draggable属性
                props: {
                // draggable: 'true'
                },
                style: {
                cursor: 'pointer'
                },
                on: {
                // 鼠标移入
                mouseenter: (event) => {
                    // 兼容IE
                    var ev = event || window.event
                    ev.target.draggable = true
                },
                // 开始拖拽
                dragstart: (event) => {
                    // 兼容IE
                    var ev = event || window.event
                    // 阻止冒泡
                    ev.stopPropagation()
                    // 得到源目标数据
                    this.sourceObj = record
                    console.log("sourceObj="+JSON.stringify(record))
                },
                // 拖动元素经过的元素
                dragover: (event) => {
                    // 兼容 IE
                    var ev = event || window.event
                    // 阻止默认行为
                    ev.preventDefault()
                },
                // 鼠标松开
                drop: (event) => {
                    // 兼容IE
                    var ev = event || window.event
                    // 阻止冒泡
                    ev.stopPropagation()
                    // 得到目标数据
                    this.targetObj = record
                    console.log("targetObj="+JSON.stringify(record))
                }
                }
            }
        },
    }
}
</script>





// WEBPACK FOOTER //
// src/components/toker/visitor.vue